const CustomerState = Object.freeze({
    Consultant: 0,
    AuthorizedUser: 1,    
  });
  
  export { CustomerState };